/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Injectable } from '@angular/core';
import { UtilService } from './util.service';

/**
 * @export
 * @class StaticDataStoreService
 */
@Injectable()
export class StaticDataStoreService {
    private datastore = new Map<string, any>();

    /**
     * Creates an instance of StaticDataStoreService.
     * @param {UtilService} utilService
     *
     * @memberOf StaticDataStoreService
     */
    constructor(private utilService: UtilService) {
    }

    /**
     * This is used to get Static Data Store
     * @returns
     * @memberOf StaticDataStoreService
     */
    getDataStore() {
        return this.datastore;
    }

    /**
     * This is used to get Value from static Data Store
     * @param {string} key
     * @returns
     * @memberOf StaticDataStoreService
     */
    getValue(key: string) {
        const value = this.datastore.get(key);
        return value;
    }

    /**
     * This is used to invalidate the Data Store
     * @memberOf StaticDataStoreService
     */
    invalidateDataStore() {
        this.datastore = new Map<string, any>();
    }

    /**
     * This is used to put value in Static Data Store
     * @param {string} key
     * @param {*} value
     * @memberOf StaticDataStoreService
     */
    putValue(key: string, value: any) {
        this.datastore.set(key, value);
    }

    /**
     * This is used to remove value from Static Data Store
     * @param {string} key
     * @memberOf StaticDataStoreService
     */
    removeValue(key: string) {
        this.datastore.delete(key);
    }

}
